const statefulPropsDefaults = {
  stateful: false
};
export {
  statefulPropsDefaults as s
};
//# sourceMappingURL=useStateful.props.js.map
